module.exports = __webpack_public_path__ + "img/google.b4604773.png";